module.exports = __webpack_public_path__ + "img/gal-12.0709a3b0.jpeg";